import type { IconDefinition } from '../index.tsx';

export const iconHistory: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconHistory',
  icon: [
    16,
    16,
    [],
    '',
    'M10.25 7H5.75C5.3125 7 5 7.34375 5 7.75C5 8.1875 5.3125 8.5 5.75 8.5H10.25C10.6562 8.5 11 8.1875 11 7.75C11 7.34375 10.6562 7 10.25 7ZM7.25 10H5.75C5.3125 10 5 10.3438 5 10.75C5 11.1875 5.3125 11.5 5.75 11.5H7.25C7.65625 11.5 8 11.1875 8 10.75C8 10.3438 7.65625 10 7.25 10ZM10.25 4H5.75C5.3125 4 5 4.34375 5 4.75C5 5.1875 5.3125 5.5 5.75 5.5H10.25C10.6562 5.5 11 5.1875 11 4.75C11 4.34375 10.6562 4 10.25 4ZM12 0H4C2.875 0 2 0.90625 2 2V14C2 15.125 2.875 16 4 16H12C13.0938 16 14 15.125 14 14V2C14 0.90625 13.0938 0 12 0ZM12.5 14C12.5 14.2812 12.25 14.5 12 14.5H4C3.71875 14.5 3.5 14.2812 3.5 14V2C3.5 1.75 3.71875 1.5 4 1.5H12C12.25 1.5 12.5 1.75 12.5 2V14Z',
  ],
};
